import { Box, BoxProps } from "@chakra-ui/react"
import { usePathNavigator } from "./PathNavigatorContext"

const Highlight = ({ staticStyle }: { staticStyle?: BoxProps["css"] }) => {
  const { highlightStyle } = usePathNavigator()

  return (
    <Box
      as="div"
      className="PathNavigatorHighlight"
      position="absolute"
      left={0}
      bg="whiteAlpha.200"
      borderRadius="md"
      transition="all 0.05s ease-in-out"
      zIndex={0} // Ensure it's behind text
      css={{ "&": staticStyle ?? highlightStyle }}
    />
  )
}

export default Highlight
